module.exports = __webpack_public_path__ + "static/media/22.c160dc56.jpg";